import baseService from '../shared/baseService';

const clientClipperService = (clientId: number) => baseService(`clients/${clientId}/clippers`);

export default { 
    clientClipperService
};

